// Product data extracted from the prompt - Complete catalog with all products
export const products = [
  // New Offers Section - First 50 products from prompt
  {
    id: 1,
    name: "Rajwadi",
    category: "Dress",
    price: "1,650 Taka",
    image: "https://sanveesbytony.com/uploads/media/e66f1af0-a567-4f0f-8442-bd32226d69e3.jpg?fit=crop&h=300&w=300&s=b84cd653967793bb9745f8818fa798f7",
    orderLink: "https://sanveesbytony.com/product/rajwadi-1",
    section: "newOffers"
  },
  {
    id: 2,
    name: "TARA-B",
    category: "Saree",
    price: "2,840 Taka",
    image: "https://sanveesbytony.com/uploads/media/be2ea471-4f1f-4620-836f-012639608970.jpg?fit=crop&h=300&w=300&s=cd2220e6783e4e1aa61322d22e35afa3",
    orderLink: "https://sanveesbytony.com/product/tara-b",
    section: "newOffers"
  },
  {
    id: 3,
    name: "Pannel",
    category: "Dress",
    price: "1,690 Taka",
    image: "https://sanveesbytony.com/uploads/media/d3a64fb5-ae7d-4535-a741-f1a6fdae0b7b.jpg?fit=crop&h=300&w=300&s=55479657ddea9d7fcd785233624f79b0",
    orderLink: "https://sanveesbytony.com/product/pannel",
    section: "newOffers"
  },
  {
    id: 4,
    name: "Dilara",
    category: "Cotton Dress",
    price: "1,090 Taka",
    image: "https://sanveesbytony.com/uploads/media/62ba2a3a-dc55-4224-a88a-c23137bc7e6e.jpg?fit=crop&h=300&w=300&s=9da0174f2ca9c8e13c65c2a6c873c391",
    orderLink: "https://sanveesbytony.com/product/dilara-1",
    section: "newOffers"
  },
  {
    id: 5,
    name: "Nihab",
    category: "Cotton Dress",
    price: "1,180 Taka",
    image: "https://sanveesbytony.com/uploads/media/0869693e-7186-40c1-8af1-fb577a79822d.jpg?fit=crop&h=300&w=300&s=606c7112e00c31226737e382df08a261",
    orderLink: "https://sanveesbytony.com/product/nihab",
    section: "newOffers"
  },
  {
    id: 6,
    name: "Pure Lawn Cotton 3",
    category: "Cotton Dress",
    price: "1,099 Taka",
    image: "https://sanveesbytony.com/uploads/media/da831d83-71c4-4da1-b14e-1cdd58ecafd8.jpg?fit=crop&h=300&w=300&s=8be7680385ee531a2eed8711c2a86fd8",
    orderLink: "https://sanveesbytony.com/product/pure-lawn-cotton-3-7",
    section: "newOffers"
  },
  {
    id: 7,
    name: "ESHAL",
    category: "Dress",
    price: "1,350 Taka",
    image: "https://sanveesbytony.com/uploads/media/5feac6b1-e171-49f1-bd08-2ea5bde64e77.png?fit=crop&h=300&w=300&s=b60a97d61c62f27d8a9ca50e0a0d5656",
    orderLink: "https://sanveesbytony.com/product/eshal",
    section: "newOffers"
  },
  {
    id: 8,
    name: "Dilara",
    category: "Dress",
    price: "1,099 Taka",
    image: "https://sanveesbytony.com/uploads/media/b1408775-ab8e-4dc0-bf03-baa15f482b5f.jpg?fit=crop&h=300&w=300&s=f6f72fd7a753f8c267491ab4682e09d8",
    orderLink: "https://sanveesbytony.com/product/dilara",
    section: "newOffers"
  },
  {
    id: 9,
    name: "Fazrak",
    category: "Dress",
    price: "999 Taka",
    image: "https://sanveesbytony.com/uploads/media/2d931c1c-0794-46e8-a87d-95a4b6db2950.jpg?fit=crop&h=300&w=300&s=f4bab8a1601eb51955382e89788cb863",
    orderLink: "https://sanveesbytony.com/product/fazrak-3",
    section: "newOffers"
  },
  {
    id: 10,
    name: "Diya",
    category: "Dress",
    price: "1,680 Taka",
    image: "https://sanveesbytony.com/uploads/media/aeb0b1a2-30c3-40ba-b3c2-86ebb64ac878.png?fit=crop&h=300&w=300&s=50460fa17e63a9b3b6ea3dc58285b503",
    orderLink: "https://sanveesbytony.com/product/diya%20",
    section: "newOffers"
  },
  {
    id: 11,
    name: "Nowshin",
    category: "Dress",
    price: "1,850 Taka",
    image: "https://sanveesbytony.com/uploads/media/36f3133b-4943-4483-be75-fe8e61fdd8d5.jpg?fit=crop&h=300&w=300&s=5dc99303e5bf6c894c52869e39d07ed3",
    orderLink: "https://sanveesbytony.com/product/nowshin",
    section: "newOffers"
  },
  {
    id: 12,
    name: "Dibala",
    category: "Dress",
    price: "1,290 Taka",
    image: "https://sanveesbytony.com/uploads/media/9ba9a2d4-7b58-4a0f-af66-7abb196e6868.jpg?fit=crop&h=300&w=300&s=fcf0cea28e11c3afcf328f495c3e8f97",
    orderLink: "https://sanveesbytony.com/product/dibala",
    section: "newOffers"
  },
  {
    id: 13,
    name: "CHAINA BAG",
    category: "Bag",
    price: "2,840 Taka",
    image: "https://sanveesbytony.com/uploads/media/3e1057ce-4ef6-4b9b-a032-5ab28dd7a364.png?fit=crop&h=300&w=300&s=f5d3fed7d1412d2259eefb7e2dbe4261",
    orderLink: "https://sanveesbytony.com/product/chaina-bag-4",
    section: "newOffers"
  },
  {
    id: 14,
    name: "Cotton Stitch",
    category: "Cotton Dress",
    price: "1,050 Taka",
    image: "https://sanveesbytony.com/uploads/media/51dc3f67-ff33-4170-a74e-f67a06cdd0a5.jpg?fit=crop&h=300&w=300&s=0aa8a2003d20123e7575a4b25dc6c586",
    orderLink: "https://sanveesbytony.com/product/cotton-stitch-6",
    section: "newOffers"
  },
  {
    id: 15,
    name: "pure cotton 5",
    category: "Dress",
    price: "650 Taka",
    image: "https://sanveesbytony.com/uploads/media/03321451-0022-406b-9b63-00897780510a.png?fit=crop&h=300&w=300&s=c621d8b502342125641cf147d47ecb79",
    orderLink: "https://sanveesbytony.com/product/pure-cotton-5-2",
    section: "newOffers"
  },
  {
    id: 16,
    name: "Chikenkari",
    category: "Dress",
    price: "1,580 Taka",
    image: "https://sanveesbytony.com/uploads/media/1d51a468-a0a5-4043-b1ac-b1283badd679.jpg?fit=crop&h=300&w=300&s=288c0782cbb1e982afe0f395f3b6d6c6",
    orderLink: "https://sanveesbytony.com/product/chikenkari-34",
    section: "newOffers"
  },
  {
    id: 17,
    name: "RAJEL",
    category: "Dress",
    price: "1,699 Taka",
    image: "https://sanveesbytony.com/uploads/media/48bf9a73-105a-4a97-be4f-23a9b0c3043a.jpg?fit=crop&h=300&w=300&s=f529a6a7281b69a8b55e0201cc1e5c4e",
    orderLink: "https://sanveesbytony.com/product/rajel",
    section: "newOffers"
  },
  {
    id: 18,
    name: "SF-SANA",
    category: "Dress",
    price: "1,780 Taka",
    image: "https://sanveesbytony.com/uploads/media/0e8d78d1-1ac9-42c2-8c94-4720a860cd7d.jpg?fit=crop&h=300&w=300&s=8ea8a2e2c393dc0b17e8556047dbf6bd",
    orderLink: "https://sanveesbytony.com/product/sf-sana",
    section: "newOffers"
  },
  {
    id: 19,
    name: "Cotton Embroidery 1",
    category: "Dress",
    price: "2,150 Taka",
    image: "https://sanveesbytony.com/uploads/media/07c8c800-a3bb-414c-b2c7-d34935438e78.jpg?fit=crop&h=300&w=300&s=46f136752c9e7874098a6f9e958f4bc8",
    orderLink: "https://sanveesbytony.com/product/cotton-embroidery1",
    section: "newOffers"
  },
  {
    id: 20,
    name: "Self Printed",
    category: "Saree",
    price: "2,040 Taka",
    image: "https://sanveesbytony.com/uploads/media/53afd121-1804-4bca-9da0-78c3b8ad5789.jpg?fit=crop&h=300&w=300&s=591a8e0ee938f4ccefb00d689ac4e373",
    orderLink: "https://sanveesbytony.com/product/self-printed-2",
    section: "newOffers"
  },
  // Continue New Offers - More products from prompt
  {
    id: 21,
    name: "Georgette",
    category: "Dress",
    price: "2,250 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/851ac03b-b3bc-4904-9a16-cedafa6a69a2.jpg",
    orderLink: "https://sanveesbytony.com/product/georgette-7",
    section: "newOffers"
  },
  {
    id: 22,
    name: "Zimmi-Cho",
    category: "Dress",
    price: "4,400 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/198e186c-36cf-4fa5-9954-b9c411780af7.jpg",
    orderLink: "https://sanveesbytony.com/product/zimmi-cho",
    section: "newOffers"
  },
  {
    id: 23,
    name: "Raja Badsha",
    category: "Dress",
    price: "1,750 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/4475983b-a1ac-4f28-bcbd-c08aee6fed0e.png",
    orderLink: "https://sanveesbytony.com/product/raja-badsha-6",
    section: "newOffers"
  },
  {
    id: 24,
    name: "Hazrak",
    category: "Dress",
    price: "2,450 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/be22ec93-eeb0-42ab-8fe9-1aa11dd6546b.jpg",
    orderLink: "https://sanveesbytony.com/product/hazrak-3",
    section: "newOffers"
  },
  {
    id: 25,
    name: "Maslin Cotton Karchup",
    category: "Dress",
    price: "1,450 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/f3f31404-fb99-4d45-8727-813cc6d54f07.jpg",
    orderLink: "https://sanveesbytony.com/product/maslin-cotton-karchup",
    section: "newOffers"
  },
  {
    id: 26,
    name: "Raj Silk Villa Crispy",
    category: "Saree",
    price: "1,480 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/0437f9db-6838-4aaa-ae6c-0bd3ab55b0a0.jpg",
    orderLink: "https://sanveesbytony.com/product/raj-silk-villa-crispy-1",
    section: "newOffers"
  },
  {
    id: 27,
    name: "Silk Katan Sharee",
    category: "Saree",
    price: "3,850 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/28d0b04a-861c-4cb1-832a-da13bd769fad.jpg",
    orderLink: "https://sanveesbytony.com/product/silk-katan-sharee-1",
    section: "newOffers"
  },
  {
    id: 28,
    name: "Organza Maslin",
    category: "Dress",
    price: "2,050 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/d3a02720-3136-411f-a4e3-07faaca69dae.jpg",
    orderLink: "https://sanveesbytony.com/product/organza-maslin-2",
    section: "newOffers"
  },
  {
    id: 29,
    name: "Pure Lawn Cotton 3",
    category: "Dress",
    price: "550 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/d36e13a1-c675-4e95-a47c-da192db70e71.jpg",
    orderLink: "https://sanveesbytony.com/product/pure-lawn-cotton-3-4",
    section: "newOffers"
  },
  {
    id: 30,
    name: "Chiffon Georgette Savoraski",
    category: "Saree",
    price: "1,480 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/1b054730-7662-49c5-b8f3-047dd97e01bf.jpeg",
    orderLink: "https://sanveesbytony.com/product/chiffon-georgette-savoraski",
    section: "newOffers"
  },
  {
    id: 31,
    name: "Pure Silk & Organza Mixed",
    category: "Dress",
    price: "1,650 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/91cacc76-0088-4cb7-8429-f903d1326a79.jpeg",
    orderLink: "https://sanveesbytony.com/product/pure-silk-organza-mixed",
    section: "newOffers"
  },
  {
    id: 32,
    name: "Chanderi Silk",
    category: "Saree",
    price: "1,480 Taka",
    image: "https://sanveesbytony.com/uploads/media/34c26bfc-5692-4f10-8386-8edacfa99049.png?fit=crop&h=300&w=300&s=84044bc92c272a7d3cf5119a834e5776",
    orderLink: "https://sanveesbytony.com/product/chanderi-silk-28",
    section: "newOffers"
  },
  {
    id: 33,
    name: "Silk Stitch",
    category: "Dress",
    price: "1,480 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/2fcbbc40-f898-4bc3-b8e6-c08080cddbb7.jpg",
    orderLink: "https://sanveesbytony.com/product/silk-stitch-1",
    section: "newOffers"
  },
  {
    id: 34,
    name: "Maslin",
    category: "Dress",
    price: "1,680 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/66f4a508-20a9-455a-b69b-a4a3a191ae04.jpg",
    orderLink: "https://sanveesbytony.com/product/maslin-8",
    section: "newOffers"
  },
  {
    id: 35,
    name: "Katan Sharee",
    category: "Saree",
    price: "1,680 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/1aeed7f4-d38b-4462-99f1-6f126289d9c6.jpg",
    orderLink: "https://sanveesbytony.com/product/katan-sharee-25",
    section: "newOffers"
  },
  {
    id: 36,
    name: "Kalamkar",
    category: "Dress",
    price: "750 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/7480dcac-473e-49c9-b3fe-09187df38b68.png",
    orderLink: "https://sanveesbytony.com/product/kalamkar-7",
    section: "newOffers"
  },
  {
    id: 37,
    name: "Kumarika",
    category: "Dress",
    price: "1,590 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/38f81fc6-03b9-46ad-b801-af7621047a8e.jpg",
    orderLink: "https://sanveesbytony.com/product/kumarika",
    section: "newOffers"
  },
  {
    id: 38,
    name: "Chanderi Silk",
    category: "Saree",
    price: "1,280 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/851587e6-8402-4c34-9635-63b30b1be0d1.jpg",
    orderLink: "https://sanveesbytony.com/product/chanderi-silk-1",
    section: "newOffers"
  },
  {
    id: 39,
    name: "Raj Silk",
    category: "Saree",
    price: "1,650 Taka",
    image: "https://sanveesbytony.com/uploads/media/a9fcdf51-bd83-4508-9a9c-af54c2e621d9.png?fit=crop&h=300&w=300&s=28e3ed552038669656e286efbf44621e",
    orderLink: "https://sanveesbytony.com/product/raj-silk-2",
    section: "newOffers"
  },
  {
    id: 40,
    name: "katan Sharee",
    category: "Saree",
    price: "1,680 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/3eba4c06-684f-4196-ae56-51f4d5e9b441.jpeg",
    orderLink: "https://sanveesbytony.com/product/katan-sharee-15",
    section: "newOffers"
  },
  {
    id: 41,
    name: "Indonesian Silk",
    category: "Dress",
    price: "850 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/cf9725a6-fde5-488b-b332-44d32796c751.jpeg",
    orderLink: "https://sanveesbytony.com/product/indonesian-silk-8",
    section: "newOffers"
  },
  {
    id: 42,
    name: "Sharee",
    category: "Saree",
    price: "1,250 Taka",
    image: "https://sanveesbytony.com/uploads/media/7fa7d2f6-6bcf-436e-8675-6d0bb1f9a383.png?fit=crop&h=300&w=300&s=04a5a7d489acf7fffd0d3c3b223cc2e6",
    orderLink: "https://sanveesbytony.com/product/pure-chiffon-22",
    section: "newOffers"
  },
  {
    id: 43,
    name: "Cotton Dress",
    category: "Dress",
    price: "750 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/3014aacb-be2e-46f2-a624-4dba907c0a07.jpeg",
    orderLink: "https://sanveesbytony.com/product/cotton-dress-12",
    section: "newOffers"
  },
  {
    id: 44,
    name: "Sf-Fatehi",
    category: "Dress",
    price: "1,650 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/3f6bab63-ab58-4a97-841c-452b480b97c9.jpg",
    orderLink: "https://sanveesbytony.com/product/sf-fatehi",
    section: "newOffers"
  },
  {
    id: 45,
    name: "Chapai",
    category: "Saree",
    price: "1,250 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/8e384351-7e6c-47a5-9e87-6a0ad39b0205.jpg",
    orderLink: "https://sanveesbytony.com/product/chapai-7",
    section: "newOffers"
  },
  {
    id: 46,
    name: "Chiffon Sharee",
    category: "Saree",
    price: "1,250 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/5b8d92b1-103f-4b7c-9c1b-4356a2970f6e.jpeg",
    orderLink: "https://sanveesbytony.com/product/chiffon-sharee",
    section: "newOffers"
  },
  {
    id: 47,
    name: "Chundri",
    category: "Saree",
    price: "750 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/eba28b3b-5558-46c7-a0ff-18116f462a08.jpeg",
    orderLink: "https://sanveesbytony.com/product/chundri",
    section: "newOffers"
  },
  {
    id: 48,
    name: "Half Silk",
    category: "Saree",
    price: "950 Taka",
    image: "https://sanveesbytony.com/uploads/media/181d8e5b-7188-41ca-9886-1e5f02a3c527.png?fit=crop&h=300&w=300&s=27f675917a698e16d85c04f63c041e65",
    orderLink: "https://sanveesbytony.com/product/kaira-sharee",
    section: "newOffers"
  },
  {
    id: 49,
    name: "Pure Chiffon Georgette Sharee",
    category: "Saree",
    price: "1,250 Taka",
    image: "https://sanveesbytony.com/uploads/media/8def2de8-21e5-440a-829d-08cf20e83486.png?fit=crop&h=300&w=300&s=7e8c01a83911844b7b8e8ee6df6bf9e6",
    orderLink: "https://sanveesbytony.com/product/pure-chiffon-georgette-sharee-2",
    section: "newOffers"
  },
  {
    id: 50,
    name: "Maslin Cotton",
    category: "Dress",
    price: "1,490 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/32bd48a2-0fde-4d5c-a8ee-a17a87220391.jpeg",
    orderLink: "https://sanveesbytony.com/product/maslin-cotton-3",
    section: "newOffers"
  },
  // Dress Collection
  {
    id: 51,
    name: "Pure Cotton",
    category: "Dress",
    price: "1,280 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/abaf66a3-6176-4758-870a-43bac116de5d.jpeg",
    orderLink: "https://sanveesbytony.com/product/pure-cotton-16",
    section: "dress"
  },
  {
    id: 52,
    name: "Pure Chiffon Georgette",
    category: "Dress",
    price: "2,250 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/9e0b0725-a132-4f08-a67d-a6ca06ee374e.jpeg",
    orderLink: "https://sanveesbytony.com/product/pure-chiffon-georgette",
    section: "dress"
  },
  {
    id: 53,
    name: "Cherry Silk Co Orde's",
    category: "Western Collection",
    price: "999 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/8d6391dd-79cd-4e1b-a874-28ae3040001b.jpg",
    orderLink: "https://sanveesbytony.com/product/cherry-silk-co-ordes",
    section: "western"
  },
  {
    id: 54,
    name: "Myra Maslin",
    category: "Premium Sharee",
    price: "2,990 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/ac6e1f3f-f30d-4593-b823-986add1a0ccd.jpg",
    orderLink: "https://sanveesbytony.com/product/myra-maslin",
    section: "premium"
  },
  {
    id: 55,
    name: "Komola Sondory",
    category: "Saree",
    price: "1,850 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/32de72e9-501f-4dd6-8d56-c480b1dfc48b.png",
    orderLink: "https://sanveesbytony.com/product/komla-sondory",
    section: "saree"
  },
  // More Dress Collection
  {
    id: 56,
    name: "Charizma",
    category: "Dress",
    price: "2,250 Taka",
    image: "https://sanveesbytony.com/uploads/media/39cab4bd-c08d-4196-8540-176b0dffff1f.png?fit=crop&h=300&w=300&s=5330801fade10c230c02c3854564dd88",
    orderLink: "https://sanveesbytony.com/product/charizma-5",
    section: "dress"
  },
  {
    id: 57,
    name: "Rafsa",
    category: "Dress",
    price: "1,490 Taka",
    image: "https://sanveesbytony.com/uploads/media/985bd182-5b2b-4cb5-95e6-44695c597245.png?fit=crop&h=300&w=300&s=4d08e9da3246ef2305c2ccaf07c7f269",
    orderLink: "https://sanveesbytony.com/product/rafsa",
    section: "dress"
  },
  {
    id: 58,
    name: "Tie Dye",
    category: "Dress",
    price: "1,290 Taka",
    image: "https://sanveesbytony.com/uploads/media/e2dd6ac2-9bef-493d-94b4-638e527a6e9b.jpg?fit=crop&h=300&w=300&s=2c859dbac4f0dd4aaf324ac5a66891d5",
    orderLink: "https://sanveesbytony.com/product/tie-dye-5",
    section: "dress"
  },
  {
    id: 59,
    name: "GARARA",
    category: "Dress",
    price: "1,680 Taka",
    image: "https://sanveesbytony.com/uploads/media/6bf77af1-a5e6-46af-89d5-12e9d5f5d026.png?fit=crop&h=300&w=300&s=b61ffea1f38056c338b3f3e4d5163ef6",
    orderLink: "https://sanveesbytony.com/product/garara-1",
    section: "dress"
  },
  {
    id: 60,
    name: "Dilba",
    category: "Dress",
    price: "1,980 Taka",
    image: "https://sanveesbytony.com/uploads/media/628801f2-2b68-4277-a897-ee8bbc5fdd64.jpg?fit=crop&h=300&w=300&s=b4350e0e1b167c0529d1c9e79234ebcf",
    orderLink: "https://sanveesbytony.com/product/drees-1",
    section: "dress"
  },
  {
    id: 61,
    name: "Karchupi Work dress",
    category: "Dress",
    price: "1,280 Taka",
    image: "https://sanveesbytony.com/uploads/media/65c52171-2354-43c0-9463-17161273ef90.png?fit=crop&h=300&w=300&s=403580168ed9a1f2aa27892b3425efeb",
    orderLink: "https://sanveesbytony.com/product/karchupi-work-dress",
    section: "dress"
  },
  {
    id: 62,
    name: "Chandri",
    category: "Dress",
    price: "1,350 Taka",
    image: "https://sanveesbytony.com/uploads/media/e0402fb0-f967-485b-bd18-ada7978cf893.png?fit=crop&h=300&w=300&s=40a90900ba62f331682b1270e07e5f00",
    orderLink: "https://sanveesbytony.com/product/joypuri-n",
    section: "dress"
  },
  {
    id: 63,
    name: "Katan 0",
    category: "Dress",
    price: "2,080 Taka",
    image: "https://sanveesbytony.com/uploads/media/7c7f0638-31e2-4fe1-88f6-5cefcb57ce46.jpg?fit=crop&h=300&w=300&s=48d5a070e2dc1c692418485d827a066d",
    orderLink: "https://sanveesbytony.com/product/katan-0-2",
    section: "dress"
  },
  {
    id: 64,
    name: "Chandri Silk",
    category: "Dress",
    price: "999 Taka",
    image: "https://sanveesbytony.com/uploads/media/e4c951f4-367b-4819-9dab-e507a0d22a30.jpg?fit=crop&h=300&w=300&s=a602edd9807d02b0a460c479595f85a1",
    orderLink: "https://sanveesbytony.com/product/chandri-silk-2",
    section: "dress"
  },
  {
    id: 65,
    name: "Lahore",
    category: "Dress",
    price: "2,250 Taka",
    image: "https://sanveesbytony.com/uploads/media/1648b86d-c7c0-4902-bef2-34566acd9531.jpg?fit=crop&h=300&w=300&s=13608a382c7aa03614e106d895439ce8",
    orderLink: "https://sanveesbytony.com/product/lahore-7",
    section: "dress"
  },
  {
    id: 66,
    name: "Balaji",
    category: "Dress",
    price: "2,180 Taka",
    image: "https://sanveesbytony.com/uploads/media/6d0b4964-b8f1-4da8-846e-08d807aa7797.jpg?fit=crop&h=300&w=300&s=1368b8ecbea2699d0a5d094b122f5a92",
    orderLink: "https://sanveesbytony.com/product/balaji",
    section: "dress"
  },
  // Premium Collection
  {
    id: 67,
    name: "Indian Boutiques",
    category: "Premium Collection",
    price: "3,250 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/bf37e361-4c50-4bab-bde6-230ccc680162.jpg",
    orderLink: "https://sanveesbytony.com/product/indian-boutiques",
    section: "premium"
  },
  {
    id: 68,
    name: "Jamdani",
    category: "Premium Collection",
    price: "2,080 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/f02e7707-43df-428d-b239-700076ce5d29.png",
    orderLink: "https://sanveesbytony.com/product/jamdani-8",
    section: "premium"
  },
  {
    id: 69,
    name: "RAJGURU",
    category: "Premium Collection",
    price: "3,850 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/34c3af79-4a33-46af-adb8-e9d656468fdf.jpg",
    orderLink: "https://sanveesbytony.com/product/rajguru",
    section: "premium"
  },
  {
    id: 70,
    name: "RAHIR",
    category: "Premium Collection",
    price: "1,850 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/941dd893-9e18-4e55-9cef-71cc19ae0168.jpg",
    orderLink: "https://sanveesbytony.com/product/rahir",
    section: "premium"
  },
  {
    id: 71,
    name: "Vinay Tasor",
    category: "Premium Collection",
    price: "3,550 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/906d3db7-60a5-4eb2-be6f-03acdf9be2dd.jpg",
    orderLink: "https://sanveesbytony.com/product/vinay-tasor",
    section: "premium"
  },
  {
    id: 72,
    name: "Semi Stitch",
    category: "Premium Collection",
    price: "1,950 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/b5123287-7f9c-49b8-b2ca-555c0a076c4c.png",
    orderLink: "https://sanveesbytony.com/product/semi-stitch-5",
    section: "premium"
  },
  {
    id: 73,
    name: "Cotton Embroidery 1",
    category: "Premium Collection",
    price: "1,450 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/d596c094-3443-4580-8947-c7da6a3ac1d8.png",
    orderLink: "https://sanveesbytony.com/product/cotton-embroidery-1-1",
    section: "premium"
  },
  {
    id: 74,
    name: "Embroidery Sequenc",
    category: "Premium Collection",
    price: "1,650 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/96ddcefa-c876-40ab-9d9e-f0c3a5218e03.jpg",
    orderLink: "https://sanveesbytony.com/product/embroidery-sequenc",
    section: "premium"
  },
  {
    id: 75,
    name: "Pure Cotton 3",
    category: "Premium Collection",
    price: "1,450 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/7b2e750d-250c-4c73-9b7d-0d98e2df813d.jpg",
    orderLink: "https://sanveesbytony.com/product/pure-cotton-3-1",
    section: "premium"
  },
  {
    id: 76,
    name: "Stone Mirror",
    category: "Premium Collection",
    price: "1,450 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/a70b1683-cb40-4c04-a11c-2dc90ea34bb6.png",
    orderLink: "https://sanveesbytony.com/product/stone-mirror-9",
    section: "premium"
  },
  {
    id: 77,
    name: "Semi Maslin",
    category: "Premium Collection",
    price: "2,280 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/28d62b29-8ad8-431d-85aa-63b44ae4f800.jpg",
    orderLink: "https://sanveesbytony.com/product/semi-maslin-3",
    section: "premium"
  },
  {
    id: 78,
    name: "Pure Maslin",
    category: "Premium Collection",
    price: "1,980 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/28377c52-0d26-4942-b52c-2e7a0518e435.jpg",
    orderLink: "https://sanveesbytony.com/product/pure-maslin-5",
    section: "premium"
  },
  {
    id: 79,
    name: "Pure Silk Cotton",
    category: "Premium Collection",
    price: "690 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/85f16829-de3a-4365-b02f-acbb075c6555.jpg",
    orderLink: "https://sanveesbytony.com/product/pure-silk-cotton-2",
    section: "premium"
  },
  // Cotton Dress Collection
  {
    id: 80,
    name: "Lawn Cotton-22",
    category: "Cotton Dress",
    price: "1,150 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/6514aa41-6f3c-4a7d-8f94-bb6cd7502cff.jpg",
    orderLink: "https://sanveesbytony.com/product/lawn-cotton-22-1",
    section: "cotton"
  },
  {
    id: 81,
    name: "Pure Cotton 2",
    category: "Cotton Dress",
    price: "780 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/aac728bf-ca6e-4a7b-9e8e-b54f206960ee.png",
    orderLink: "https://sanveesbytony.com/product/pure-cotton-2-4",
    section: "cotton"
  },
  {
    id: 82,
    name: "Cotton Embroidery 4",
    category: "Cotton Dress",
    price: "1,450 Taka",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/d596c094-3443-4580-8947-c7da6a3ac1d8.png",
    orderLink: "https://sanveesbytony.com/product/cotton-embroidery-4",
    section: "cotton"
  }
];

// Categories for navigation
export const categories = [
  {
    name: "Dress",
    image: "https://sanveesbytony.com/uploads/media/e66f1af0-a567-4f0f-8442-bd32226d69e3.jpg?fit=crop&h=300&w=300&s=b84cd653967793bb9745f8818fa798f7"
  },
  {
    name: "Saree",
    image: "https://sanveesbytony.com/uploads/media/be2ea471-4f1f-4620-836f-012639608970.jpg?fit=crop&h=300&w=300&s=cd2220e6783e4e1aa61322d22e35afa3"
  },
  {
    name: "Premium Collection",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/bf37e361-4c50-4bab-bde6-230ccc680162.jpg"
  },
  {
    name: "Cotton Dress",
    image: "https://sanveesbytony.com/uploads/media/62ba2a3a-dc55-4224-a88a-c23137bc7e6e.jpg?fit=crop&h=300&w=300&s=9da0174f2ca9c8e13c65c2a6c873c391"
  },
  {
    name: "Bag",
    image: "https://sanveesbytony.com/uploads/media/3e1057ce-4ef6-4b9b-a032-5ab28dd7a364.png?fit=crop&h=300&w=300&s=f5d3fed7d1412d2259eefb7e2dbe4261"
  },
  {
    name: "Western Collection",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/8d6391dd-79cd-4e1b-a874-28ae3040001b.jpg"
  },
  {
    name: "Premium Sharee",
    image: "https://cdn.sanveesbytony.com/cdn-cgi/image/width=300,height=300,format=auto,fit=crop/media/ac6e1f3f-f30d-4593-b823-986add1a0ccd.jpg"
  }
];

// Helper functions
export const getProductsBySection = (section) => {
  return products.filter(product => product.section === section);
};

export const getProductsByCategory = (category) => {
  return products.filter(product => product.category === category);
};

export const getProductById = (id) => {
  return products.find(product => product.id === parseInt(id));
};